<template>
  <div id="calculadora">
    <v-app>
      <v-content>
        <v-container>
          <v-form ref="form" v-model="valid">
            <v-layout wrap ml-4 mr-4 mb-4>
              <v-flex xs12 sm6>
                <v-layout wrap column>
                  <v-flex>
                    <h3 class="project-title">#Projeto {{this.projeto.codigo}}</h3>
                  </v-flex>
                  <v-flex>
                    <p class="info-label-text">Autor: {{this.projeto.contatoRevenda.nome}}</p>
                  </v-flex>
                  <v-flex>
                    <p class="info-label-text">Data de criação: {{this.projeto.criadoEm}}</p>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 sm6 md3 offset-lg1 text-md-right>
                <SelectProjectStep/>
              </v-flex>
              <v-flex xs12 sm6 md3 lg2 text-md-right>
                <v-btn color="#0083CA" class="white--text" @click="updateProject()">SALVAR ALTERAÇÕES</v-btn>
              </v-flex>
            </v-layout>
            <v-expansion-panel popout>
              <v-expansion-panel-content :key="1" class="expansion-header">
                <template v-slot:header>
                  <h3>Dados do cliente</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-content>
                      <v-container grid-list-xl>
                        <ProjectClient/>
                        <ProjectEnergyCost type="edit"/>
                        <ProjectGeneratorConfiguration/>
                      </v-container>
                    </v-content>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content :key="2" class="expansion-header" @input="calculateProject()">
                <template v-slot:header>
                  <h3>Características básicas do projeto</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-content>
                      <v-container grid-list-xl>
                        <ProjectBasicCharacteristics/>
                      </v-container>
                    </v-content>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content :key="3" class="expansion-header" @input="calculateProject()">
                <template v-slot:header >
                  <h3>Dados do gerador</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-content>
                      <v-container grid-list-xl>
                        <ListCompatibleGenerators type="edit" :projectId="id"/>
                      </v-container>
                    </v-content>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
              <v-expansion-panel-content :key="4" class="expansion-header">
                <template v-slot:header>
                  <h3>Informações comerciais</h3>
                </template>
                <v-card>
                  <v-card-text>
                    <v-content>
                      <v-container grid-list-xl>
                        <ProjectCommercialInformation/>
                      </v-container>
                    </v-content>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-layout align-center justify-center mt-3>
              <v-btn outline color="#021746" @click="listarProjetos()">VOLTAR PARA PROJETOS</v-btn>
              <v-btn color="#0083CA" class="white--text" @click="updateProject()">SALVAR ALTERAÇÕES</v-btn>
            </v-layout>
          </v-form>
        </v-container>
      </v-content>
      <v-dialog
        v-model="dialog"
        max-width="320"
      >
        <v-card color="#0083CA" class="white--text pa-2">
          <v-card-title class="headline">Projeto Atualizado
            <v-img class="ml-4 border" :src="confirmedUpdate"></v-img>
          </v-card-title>
        </v-card>
      </v-dialog>
    </v-app>
  </div>
</template>

<script>
  import ProjectClientData from "./ProjectClientData";
  import {mapActions, mapGetters} from "vuex";
  import ProjectBasicCharacteristics from "./ProjectBasicCharacteristics";
  import ListCompatibleGenerators from "./ListCompatibleGenerators";
  import ProjectCommercialInformation from "./ProjectCommerciaInformation";
  import ProjectClient from "./ProjectClient";
  import ProjectEnergyCost from "./ProjectEnergyCost";
  import ProjectGeneratorConfiguration from "./ProjectGeneratorConfiguration";
  import SelectProjectStep from "./SelectProjectStep";
  import axios from "axios";
  import Vue from "vue";

  export default {
    name: "EditProject",
    components: {
      SelectProjectStep,
      ProjectGeneratorConfiguration,
      ProjectEnergyCost,
      ProjectClient,
      ProjectCommercialInformation, ListCompatibleGenerators, ProjectBasicCharacteristics, ProjectClientData
    },
    computed: {
      ...mapGetters(['projeto'])
    },
    data() {
      return {
        confirmedUpdate: require('./icons/confirmedUpdate.svg'),
        id: this.$route.params.id, //query string para selecionar o projeto pelo ID
        dialog: false,
        valid: false,
      }
    },
    methods: {
      ...mapActions(['loadProject', 'calculateProject', 'resetState']),
      listarProjetos(){
        this.resetState()
        this.$router.push(`${Vue.prototype.$rotaCalculadora}`)
      },
      updateProject() {
        if (this.$refs.form.validate()) {
          axios.post(`${Vue.prototype.$apiUrl}/Projeto.svc/projeto/${this.id}/editar`, this.projeto, {withCredentials: true})
            .then(response => {
              // console.log(response)
              this.dialog = true;
            }).catch(error => {
            // console.log(error)
          })
        }
      }
    },
    async created() {
      await this.loadProject({id: this.id});
      this.calculateProject();
    },
    mounted() {
      $.ajax({
        url: this.$apiUrl + 'Session.svc/getsessions',
        dataType: 'json',
        type: 'GET',
        xhrFields: {withCredentials: true},
        error: () => {
          swal({
            title: 'É necessário estar logado',
            icon: 'warning'
          }).then(() => (location.href = '/login?redirectTo=' + location.href))
        }
      })
    }
  }
</script>

<style scoped>
  .expansion-header {
    background: #021746 !important;
    color: white !important;
    border-color: white !important;
  }

  /deep/ .primary-color {
    color: #021746;
  }

  /deep/ .content-grey {
    color: #727272;
  }

  /deep/ .topic {
    font-weight: bold;
    color: #021746;
  }

  /deep/ .primary-text {
    font-weight: bold;
    color: #0083ca;
  }

  /deep/ .generator-description {
    font-weight: normal;
    color: grey;
  }

  /deep/ .card-value {
    font-size: 1.5rem;
    color: #021746;
    font-weight: bold;
  }

  /deep/ .card-info {
    color: #727272;
    font-weight: lighter;
  }

  /deep/ .general-information {
    overflow: auto;
    max-height: 150px;
  }

  .info-label-text {
    color: #021746;
    font-size: 15px;
  }

  .project-title {
    color: #50BED3
  }

</style>
